import React from 'react'
import UpdateSupplier from './UpdateSupplier'
import EditBreadCrumb from './EditBreadCrumb'
 
function EditSupplierPage() {
    return ( 
        <div className = "container-fluid">
        <EditBreadCrumb />
        <UpdateSupplier />
        </div>
     );
}

export default EditSupplierPage;